import React, { createContext, useEffect, useState } from "react";

// plugin imports
import {
	useI18next,
	useTranslation,
} from "@herob191/gatsby-plugin-react-i18next";

// style imports

// component imports

// util imports

// svg imports

// component
const defaultValues = {
	menuOpen: false,
	setMenuOpen: () => {},
	projectOpen: null,
	setProjectOpen: () => {},
};

export const LayoutContext = createContext(defaultValues);

export const LayoutProvider = ({ children }) => {
	const { t } = useTranslation();
	const { language } = useI18next();

	const [menuOpen, setMenuOpen] = useState(false);
	const [projectOpen, setProjectOpen] = useState(null);

	// Project page navigation
	const baseUrl = language === "en" ? `/en/` : `/`;
	const navigateProject = (project = null) => {
		const slug = project?.frontmatter?.slug;
		const url = baseUrl + (slug || "");
		window.history.pushState({ project: project }, "", url);
		setProjectOpen(project);
	};

	useEffect(() => {
		const handlePopState = (event) => {
			const projectFromHistory = event.state?.project || null;
			setProjectOpen(projectFromHistory);
		};
		window.addEventListener("popstate", handlePopState);
		return () => window.removeEventListener("popstate", handlePopState);
	}, []);

	const gridTags = [
		{ label: t("Marca"), value: "brand" },
		{ label: t("Web"), value: "web" },
		{ label: t("Dirección de arte"), value: "art" },
		{ label: t("Editorial"), value: "editorial" },
		{ label: t("Fotografía"), value: "photo" },
		{ label: t("RRSS"), value: "social" },
	];

	return (
		<LayoutContext.Provider
			value={{
				...defaultValues,
				menuOpen,
				setMenuOpen,
				projectOpen,
				setProjectOpen,
				gridTags,
				navigateProject,
			}}
		>
			{children}
		</LayoutContext.Provider>
	);
};
